import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthenticationGuardService, IRefreshTokenService, RefreshTokenInterceptor, TokenService } from '@morningstar/shared/auth';
import { environment } from '@morningstar/shared/environment';
import { ClientsModule } from '@morningstar/shared/ui-kit/clients';
import { ConnectedDialogModule } from '@morningstar/shared/ui-kit/connected-dialog';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SatNativeDateModule } from 'saturn-datepicker-ext';
import { AngularMaterialModule } from './angular-material.module';
import { AnnouncementsModule } from './announcements/announcements.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouteValidationService } from './authorization/route-validation.service';
import { BceHomeComponent } from './bce-home/bce-home.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { Error404Component } from './error404/error404.component';
import { HomeComponent } from './home/home.component';
import { LoginModule } from './login/login.module';
import { DefaultLocationDialogModule } from './shared/dialogs/default-location/default-location-dialog.module';
import { MaintenanceService } from './shared/maintenance/maintenance.service';
import { SearchBarModule } from './shared/search-bar/search-bar.module';
import { SplashPageModule } from './splash-page/splash-page.module';
import { SortablejsModule } from 'ngx-sortablejs';
import { PrivacyComponent } from './privacy/privacy.component';
import { PayNowService } from '@morningstar/shared/base/pay-now-service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    Error404Component,
    BceHomeComponent,
    PrivacyComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    DashboardModule,
    FlexLayoutModule,
    HttpClientModule,
    SplashPageModule,
    AnnouncementsModule, // used in welcome page
    ConnectedDialogModule,
    DefaultLocationDialogModule,
    LoginModule,
    ClientsModule,
    SatNativeDateModule,
    SearchBarModule,
    SortablejsModule.forRoot({ animation: 150 }),
    StoreModule.forRoot(
      {},
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true
        }
      }
    ),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    AppRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true
    },
    {
      provide: 'API_BASE_URL',
      useValue: environment.spaceGeekUrl
    },
    {
      provide: IRefreshTokenService,
      useClass: TokenService
    },
    DatePipe,
    CurrencyPipe,
    RouteValidationService,
    MaintenanceService,
    AuthenticationGuardService,
    PayNowService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
